// assets/globo-float.js
(function(){
  const selectorPatterns = ['.globo-popover', '.globo-dropdown', '.globo-options-wrapper .option-list', '.select__dropdown', '.dropdown-menu', '.popover', '.globo-options-wrapper .globo-option-list'];

  function findTriggerFor(pop){
    if (pop.__globo_trigger) return pop.__globo_trigger;
    let p = pop.parentElement;
    for (let i=0;i<6 && p;i++,p=p.parentElement){
      const t = p.querySelector('select, button, .globo-options-wrapper, .globo-option');
      if (t) return t;
    }
    return document.querySelector('select, button, .globo-options-wrapper');
  }

  function movePop(pop){
    try {
      if (!pop || pop.dataset.__floated) return;
      const trigger = findTriggerFor(pop);
      if (!trigger) return;
      pop.dataset.__floated = '1';
      pop.style.position = 'absolute';
      pop.style.zIndex = '200000';
      pop.style.minWidth = (trigger.offsetWidth || 200) + 'px';
      document.body.appendChild(pop);
      const rect = trigger.getBoundingClientRect();
      const top = window.scrollY + rect.bottom + 6;
      const left = Math.max(6, window.scrollX + rect.left);
      pop.style.top = top + 'px';
      pop.style.left = left + 'px';

      function reposition(){ 
        const r = trigger.getBoundingClientRect();
        pop.style.top = (window.scrollY + r.bottom + 6) + 'px';
        pop.style.left = (window.scrollX + r.left) + 'px';
      }
      window.addEventListener('scroll', reposition, {passive:true});
      window.addEventListener('resize', reposition);
    } catch(e){
      // silent catch
      console.warn('globo-float movePop error', e);
    }
  }

  const observer = new MutationObserver(muts=>{
    muts.forEach(m=>{
      m.addedNodes.forEach(n=>{
        if (!(n instanceof HTMLElement)) return;
        selectorPatterns.forEach(sel=>{
          if (n.matches && n.matches(sel)) {
            movePop(n);
          } else if (n.querySelector && n.querySelector(sel)) {
            movePop(n.querySelector(sel));
          }
        });
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ()=>observer.observe(document.body, {childList:true, subtree:true}));
  } else {
    observer.observe(document.body, {childList:true, subtree:true});
  }

  setTimeout(()=>{
    selectorPatterns.forEach(sel=>{
      document.querySelectorAll(sel).forEach(el=>movePop(el));
    });
  }, 500);
})();